<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :width="width"
    :close-on-click-modal="false"
    :show-close="false"
    :before-close="close"
    :title="title"
    :append-to-body="true"
  >
    <slot />
    <div
      v-if="confirmText"
      slot="footer"
      class="botoom"
    >
      <el-button
        v-if="cancelShow"
        :disabled="cancelDisable"
        @click="close"
      >
        {{ cancelText }}
      </el-button>
      <el-button
        type="primary"
        :disabled="confirmDisable"
        @click="confirm"
      >
        {{ confirmText }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>

export default {
  name: 'CustomeDialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '30%',
    },
    title: {
      type: String,
      default: '标题',
    },
    cancelText: {
      type: String,
      default: '取消',
    },
    cancelDisable: {
      type: Boolean,
      default: () => false,
    },
    cancelShow: {
      type: Boolean,
      default: () => true,
    },
    confirmText: {
      type: String,
      default: '确认',
    },
    confirmDisable: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      // dialogVisible: true,
    };
  },
  watch: {
  },
  methods: {
    close() {
      this.$emit('close', false);
    },
    confirm() {
      this.$emit('confirm');
    },
  },
};
</script>
<style lang="scss" scoped>
.el-dialog__wrapper {
  ::v-deep .el-dialog {
    border-radius: 6px;
  }
  ::v-deep .el-dialog__header {
    padding: 16px 0 0 16px;
    color: rgba($--base-color-black, 0.8);
    font-weight: 500;
  }
  ::v-deep .el-dialog__body {
    padding: 30px;
  }
  ::v-deep .el-dialog__footer {
    padding: 0 0 30px 0;
  }
  .botoom {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
